export const build = ( data ) => {
    if ( !( data instanceof Array ) || !data || typeof data === 'undefined' ) {
        return [];
    }
    return data;
};
